import * as Actions from '../actions';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Actions.SET_SHOPIFYORDER_DATA:
      // If empty don't show last item
      if (!action.payload) return INITIAL_STATE;
      // Also don't bring back any attributes of old products
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
